import React from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/ui/Icon";
import { ISale } from "../../../classes/interfaces";
import { buildWhatsAppShareUrl } from "../../../helpers/whatsappShare.helper";

interface ShareButtonProps {
  sale: ISale;
  pathname: string;
}

export default function ShareButton({ sale, pathname }: ShareButtonProps) {
  if ((sale.store.cellPhone || "") === "") {
    return null;
  }

  return (
    <div style={{ padding: "0 14px 20px" }}>
      <Button
        variant="soft"
        size="lg"
        full
        onClick={() => {
          const win = window.open(buildWhatsAppShareUrl(sale, pathname), "_blank");
          if (win) {
            win.focus();
          }
        }}
      >
        <Icon name="phone" size={17} /> Compartilhar com a loja
      </Button>
    </div>
  );
}
